import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AngularSvgIconModule } from "angular-svg-icon";
@Component({
  selector: "app-error-display",
  templateUrl: "./error-display.component.html",
  styleUrls: ["./error-display.component.scss"],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
})
export class ErrorDisplayComponent {
  @Input() errorMessage: string = "";
  @Input() size: string = "";
  @Input() isSnackbarError: boolean = false;
  @Input() displayVariant: 'default' | 'dialog' = 'default';

  @Output() closeError = new EventEmitter<void>();
}
